import { GroupCard } from "@components/institution_settings/GroupCard";
import { LoadingSkeleton } from "@narmi/design_system";
import { $staffApi } from "../../api";
import styles from "./SettingsGroupGrid.module.css";
import { useContext, useEffect } from "react";
import { NotificationContext } from "cerulean/src/NotificationContext/NotificationContext";

export const SettingsGroupPanel = ({ category }: { category: string }) => {
  const { sendNotification } = useContext(NotificationContext);
  const { data: groups, isLoading } = $staffApi.useQuery(
    "get",
    "/api/institution_settings/categories/{category}/groups/",
    {
      params: { path: { category } },
    }
  );

  useEffect(() => {
    if (!isLoading && (!groups || groups.length === 0)) {
      sendNotification({
        type: "negative",
        text: "Failed to load settings groups. Please try again later.",
      });
    }
  }, [isLoading, groups, sendNotification]);

  if (isLoading) {
    return <LoadingSkeleton isLoading={true} />;
  }

  return <SettingsGroupGrid category={category} groups={groups ?? []} />;
};

const SettingsGroupGrid = ({
  category,
  groups,
}: {
  category: string;
  groups: { name: string; setting_count: number; description: string }[];
}) => {
  return (
    <div className={styles.cardGrid}>
      {groups.map((group) => (
        <GroupCard
          key={group.name}
          category={category}
          groupName={group.name}
          description={group.description}
          numberOfSettings={group.setting_count}
        />
      ))}
    </div>
  );
};
